import { css } from "lit";
//#region src/pd-order-agreement/pd-order-agreement.styles.ts
var styles = css`
  :host {
    display: block;
  }

  .agree-box {
    padding-top: 20px;
  }

  a {
    cursor: pointer;
    font-family: var(--pd-default-font-link-family);
    font-size: var(--pd-default-font-link-size);
    color: var(--pd-order-agreement-link-col, var(--pd-default-font-link-col));
  }

  a:hover {
    color: var(--pd-default-font-link-col-hover);
  }
`;
//#endregion
export { styles };
